function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NoScroll = /*#__PURE__*/_createClass(function NoScroll() {
  var _this = this;
  _classCallCheck(this, NoScroll);
  _defineProperty(this, "isOn", false);
  _defineProperty(this, "scrollbarSize", null);
  _defineProperty(this, "scrollTop", null);
  _defineProperty(this, "scrollbarSize", null);
  _defineProperty(this, "getScrollbarSize", function () {
    if (_this.scrollbarSize) return _this.scrollbarSize;
    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    _this.scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return _this.scrollbarSize;
  });
  _defineProperty(this, "hasScrollbar", function () {
    return document.documentElement.scrollHeight > window.innerHeight;
  });
  _defineProperty(this, "on", function () {
    if (typeof document === 'undefined' || _this.isOn) return;
    var doc = document.documentElement;
    _this.scrollTop = window.pageYOffset;
    if (_this.hasScrollbar()) {
      doc.style.width = "calc(100% - ".concat(_this.getScrollbarSize(), "px)");
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = "".concat(-_this.scrollTop, "px");
    doc.style.overflow = 'hidden';
    _this.isOn = true;
  });
  _defineProperty(this, "off", function () {
    var persistOnClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (typeof document === 'undefined' || !_this.isOn) return;
    if (persistOnClose) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, _this.scrollTop);
    _this.isOn = false;
  });
});
export default new NoScroll();